/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e1rmText: NonNullable<unknown>, in_the: NonNullable<unknown> }} Wrapped_Lift_E1rmInputs */

const en_us2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An estimated max strength of ${i?.e1rmText} ${i?.in_the}`)
};

const pt_br2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText} ${i?.in_the}`)
};

const es_419_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una fuerza máxima estimada de ${i?.e1rmText} ${i?.in_the}`)
};

const pt_pt2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText} ${i?.in_the}`)
};

const fr_fr2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une force max estimée de ${i?.e1rmText} ${i?.in_the}`)
};

const de_de2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine geschätzte Maximalkraft von ${i?.e1rmText} ${i?.in_the}`)
};

const it_it2_wrapped_lift_e1rm = /** @type {(inputs: Wrapped_Lift_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una forza massima stimata di ${i?.e1rmText} ${i?.in_the}`)
};

/**
* | output |
* | --- |
* | "An estimated max strength of {e1rmText} {in_the}" |
*
* @param {Wrapped_Lift_E1rmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_lift_e1rm = /** @type {((inputs: Wrapped_Lift_E1rmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Lift_E1rmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_lift_e1rm(inputs)
	if (locale === "es-419") return es_419_wrapped_lift_e1rm(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_lift_e1rm(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_lift_e1rm(inputs)
	if (locale === "de-DE") return de_de2_wrapped_lift_e1rm(inputs)
	if (locale === "it-IT") return it_it2_wrapped_lift_e1rm(inputs)
	return en_us2_wrapped_lift_e1rm(inputs)
});
export { wrapped_lift_e1rm as "wrapped.lift_e1rm" }